var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('combo-tree-common',_vm._g(_vm._b({},'combo-tree-common',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }